import {
  SelectedItem,
  SelectedItems,
} from '@root/components/checkout/product_pages/subcomponents/plan_estimator_modal/types';

export type StorageCalculatorItem = {
  categoryID: string;
  categoryName: string;
  cuft: number;
  quantity: number;
};

export const selectedItemsFromStorageCalculatorItems = (
  items: StorageCalculatorItem[] | undefined,
): SelectedItems => {
  const map = new Map<string, SelectedItem>();
  for (const item of items ?? []) {
    if (item.quantity <= 0) continue;
    map.set(item.categoryID, {
      category: {
        id: item.categoryID,
        name: item.categoryName,
        cuft: item.cuft,
      },
      quantity: item.quantity,
    });
  }
  return map;
};

export const storageCalculatorItemsFromSelectedItems = (
  items: SelectedItems,
): StorageCalculatorItem[] =>
  Array.from(items.values())
    .filter((item) => item.quantity > 0)
    .map(({ category, quantity }) => ({
      categoryID: category.id,
      categoryName: category.name,
      cuft: category.cuft,
      quantity,
    }));

export const storageCalculatorItemsForReserve = (
  items: StorageCalculatorItem[] | undefined,
) =>
  (items ?? []).map(({ categoryID, quantity }) => ({
    categoryID,
    quantity,
  }));
